import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../modal/modal.jsx';
import Box from '../box/box.jsx';
import styles from './video-guide.css';
import poster from './video-guide-poster.png';
const VideoGuide = props => (
    <Modal
        className={styles.videoContainer}
        overlayClassName={styles.videoGuideOverlay}
        onRequestClose={props.onRequestClose}
    >
        <Box className={styles.box}>
            <div className={styles.videoBox}>
                <video
                    autoPlay="autoPlay"
                    controls="1"
                    poster={poster}
                    preload="auto"
                    ref={props.setRef}
                    style={{width: '100%', height: '100%'}}
                >
                    <source
                        src={props.videoUrl}
                        type="video/mp4"
                    />
                </video>
            </div>
        </Box>
    </Modal>
);

VideoGuide.propTypes = {
    onRequestClose: PropTypes.string,
    setRef: PropTypes.func,
    videoUrl: PropTypes.string
};
VideoGuide.defaultProps = {
    // eslint-disable-next-line
    videoUrl: `//vod.hetao101.com/video/2.0%E7%89%88%E6%9C%AC%E8%BD%AC3.0%E7%89%88%E6%9C%AC%E7%9A%84%E4%BB%8B%E7%BB%8D%E8%AF%BE%E7%A8%8B-1026.mp4`
};
export default VideoGuide;
